<div class="two-fa" [ngClass]="{'hide' : showincome == false}">
    <h2>Update Income Details</h2>
    <hr>
    <div class="inner-wrapper">
        <div class="progress-steps">
            <div  class="step-count active">1
            </div>
            <div *ngIf="!showemail" class="step-count">2
            </div>
        </div>
        <p>We kindly request you to review and confirm your current annual income/net worth. Regulatory guidelines require us to update these details annually to better serve you.

        </p>
        <form class="income-form">
            <label for="cars">Gross Income P.A.</label>
            <mat-select [(value)]="selectedincome">
                <mat-option value="Below 1Lac">Below 1 Lac</mat-option>
                <mat-option value="1Lac-5Lac"> 1 Lac - 5 Lac</mat-option>
                <mat-option value="5Lac-10Lac">5 Lac - 10 Lac</mat-option>
                <mat-option value="10Lac-25Lac">10 Lac - 25 Lac</mat-option>
                <mat-option value="25Lac-1Cr">25 Lac - 1 Cr</mat-option>
                <mat-option value="Above 1Cr">Above 1 Cr</mat-option>
            </mat-select>
        </form>
        <div class="declaration">
            <mat-checkbox [checked]="defaultchecked" (change)="acknowledgement($event)" class="example-margin">I Confirm that the information provided above are true, correct and complete to the
                best of my knowledge. In the case of any of the above specific information it is found
                to be false or untrue I/WE and are aware that, I/We may be liable for it.
                In case of any changes in the above given information, on a future date, I undertake
                to inform 5paisa within 15 days of such updates.
            </mat-checkbox>
        </div>
        <div class="bottom-button-wrapper">
            <button class="btn-dark" [disabled]="btndisabled" (click)="updateincodedata();" >Proceed</button>
        </div>

    </div>
</div>
<div class="two-fa step-count-2" [ngClass]="{'hide' : showincome == true}">
    <h2>Verify Personal Details</h2>
    <hr>
    <div class="inner-wrapper">
        <div class="progress-steps">
            <div class="step-count completed">1
            </div>
            <div class="step-count active">2
            </div>
        </div>
        <h6>Please confirm that below details belongs to
        </h6>
        <form class="income-form">
            <label for="">{{mobile}}</label>
            <select>
                <option>Self</option>
            </select>
        </form>
        <form class="income-form">
            <label for="">{{email}}</label>
            <select>
                <option>Self</option>
            </select>
        </form>
        <div class="declaration">
        </div>
        <div class="bottom-button-wrapper">
            <button class="btn-dark" (click)="closeincomepopup()" >Confirm</button>
        </div>

    </div>
</div>